'use strict';

var DataExtractCompletedTransformerFactory = function DataExtractCompletedTransformerFactory(DataTransformer, momentService) {
  function DataExtractCompletedTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'completed-mode';
    this.targetType = 'data-extract-completed';
    this.priority = 1;
  }
  DataExtractCompletedTransformer.prototype = Object.create(DataTransformer.prototype);
  DataExtractCompletedTransformer.constructor = DataExtractCompletedTransformer;
  DataExtractCompletedTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  DataExtractCompletedTransformer.prototype.isCacheable = function () {
    return false;
  };
  DataExtractCompletedTransformer.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType;
  };
  DataExtractCompletedTransformer.prototype.transform = function (data) {
    var length = data.domain.length;
    for (var i = 0; i < length; i++) {
      data.domain[i].lastRun = momentService.of(data.domain[i].lastRun, momentService.FIELD.LAST_RUN);
    }
    return data.domain;
  };
  return DataExtractCompletedTransformer;
};
DataExtractCompletedTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = DataExtractCompletedTransformerFactory;